import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type { VendorMaterialPricingPlan } from '../types';
import type {
  UseGetVendorMaterialPricingPlanQueryKey,
  UseGetVendorMaterialPricingPlanParams,
} from './types';
import { getUseGetVendorsMaterialPricingPlanQueryKey } from './utils';

export const useGetVendorMaterialPricingPlan: QueryFunction<
  VendorMaterialPricingPlan,
  [UseGetVendorMaterialPricingPlanParams],
  UseGetVendorMaterialPricingPlanQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getUseGetVendorsMaterialPricingPlanQueryKey(params);

  return useQuery<
    VendorMaterialPricingPlan,
    unknown,
    VendorMaterialPricingPlan,
    UseGetVendorMaterialPricingPlanQueryKey
  >({
    queryKey,
    queryFn: ({ signal }) => {
      return request(
        `/vendors/vendor_material_pricing_plans/${params.vendorMaterialPricingPlanId}`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      );
    },
    enabled: !!params.vendorMaterialPricingPlanId,
    ...queryOptions,
  });
};
